<template>
    <div>
        <breadcrumb :items="breadcrumbs"></breadcrumb>
        <v-container fluid>
            <div class="d-flex mb-4">
                <h2>{{ $t("Enquiries") }}</h2>
                <v-spacer></v-spacer>
                <template>
                    <div>
                        <v-btn 
                            color="primary" 
                            dark 
                            outlined 
                            class="mr-2"
                            @click="$router.push({name: 'Enquiries'})"
                        >
                            Cancel
                        </v-btn>
                        <v-btn 
                            color="primary"
                            dark 
                            depressed
                            @click="saveEnquery"
                        >
                            Submit
                        </v-btn>
                    </div>
                </template>
            </div>
            <v-card elevation="0" class="pa-0" color="">
                <v-form
                    ref="form"
                >
                    <v-card-text>
                        <v-row class="pa-0">
                            <v-col cols="4">
                                <label
                                    class="body-2"
                                >
                                    Subject
                                    <span class="red--text">*</span>
                                </label>
                                <v-text-field
                                    outlined
                                    dense
                                    v-model="subject"
                                    :rules="rules.subject"
                                >

                                </v-text-field>
                            </v-col>
                            <v-col cols="4">
                                <label
                                    class="body-2"
                                >
                                Area of Enquiry
                                    <span class="red--text">*</span>
                                </label>
                                <v-text-field
                                    outlined
                                    dense
                                    v-model="area"
                                    :rules="rules.area"
                                >

                                </v-text-field>
                            </v-col>
                            <v-col cols="4">
                                <label
                                    class="body-2"
                                >
                                Type
                                    <span class="red--text">*</span>
                                </label>
                                <v-select
                                    outlined
                                    dense
                                    v-model="type"
                                    :rules="rules.type"
                                    :items="['Question', 'Incident', 'Problem']"
                                >

                                </v-select>
                            </v-col>
                            <v-col cols="12">
                                <label
                                    class="body-2"
                                >
                                Upload Image
                                </label>
                                <div class="form">
                                    <div v-if="!file">
                                        <div :class="['dropZone', dragging ? 'dropZone-over' : '']" @dragenter="dragging = true" @dragleave="dragging = false">
                                            <div class="dropZone-info" @drag="onChange">
                                                <span class="fa fa-cloud-upload dropZone-title"></span>
                                                <span class="dropZone-title">
                                                    <v-icon x-large color="primary">mdi-tray-arrow-up</v-icon>
                                                </span>
                                                <div class="d-flex-start">
                                                    <div class="primary--text">Browse </div>
                                                </div>
                                                <div class="dropZone-upload-limit-info">
                                                    <div>or drop your file (png, jpg, jpeg) here </div>
                                                </div>
                                            </div>
                                            <input type="file" @change="onChange">
                                        </div>
                                    </div>
                                    <div v-else class="dropZone-uploaded">
                                        <div class="dropZone-uploaded-info">
                                        <v-btn
                                            class="ma-2 white--text"
                                            @click="removeFile"
                                            color="primary"
                                            outlined
                                        >
                                            Remove File
                                            <v-icon
                                                right
                                                dark
                                            >
                                                mdi-trash-can
                                            </v-icon>
                                        </v-btn>
                                        </div>
                                    </div>
                            
                                    <div v-if="file" class="uploadedFile-info">
                                        <div>{{ file.name }}</div>
                                    </div>
                                </div>
                            </v-col>
                            <v-col cols="12">
                                <label
                                    class="body-2"
                                >
                                Description
                                <span class="red--text">*</span>
                                </label>
                                <v-textarea
                                    outlined
                                    rows="4"
                                    v-model="description"
                                    :rules="rules.description"
                                >

                                </v-textarea>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-form>
            </v-card>
        </v-container>
    </div>
</template>
<script>
import generalMixin from "@/mixins/GeneralMixin";
import loadingMixin from "@/mixins/LoadingMixin"

import EnquiryService from "@/_services/EnquiryService"

export default {
    data() {
        return {
            subject: '',
            area: '',
            description: '',
            type: '',
            file: '',
            dragging: false,
            breadcrumbs: [
                {
                    text: this.$t('dashboard'),
                    disabled: false,
                    to: '/',
                },
                {
                    text: 'Help Desk',
                    disabled: true,
                },
            ],
            rules: {
                subject: [
                    v => !!v || 'Subject is required',
                    v => this.onlyAlpha(v) || 'Subject can contain only alphbets'
                ],
                area: [
                    v => !!v || 'Area is required',
                ],
                type: [
                    v => !!v || 'Type is required',
                ],
                description: [
                    v => !!v || 'Description is required',
                ],
            }
        }
    },
    methods: {
        onChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            
            if (!files.length) {
                this.dragging = false;
                return;
            }
            
            this.createFile(files[0]);
        },
        createFile(file) {
            // if (!file.type.match('text.*')) {
            //     alert('please select txt file');
            //     this.dragging = false;
            //     return;
            // }
        
            // if (file.size > 5000000) {
            //     alert('please check file size no over 5 MB.')
            //     this.dragging = false;
            //     return;
            // }
        
            this.file = file;
            this.dragging = false;
        },
        removeFile() {
            this.file = '';
        },

        saveEnquery() {
            if(!this.$refs.form.validate()) return;
            this.startLoading();
            let formData = new FormData();
            if(this.file){
                formData.append('filename', this.file);
            }
            formData.append('subject', this.subject);
            formData.append('areaOfRequest', this.area);
            formData.append('type', this.type);
            formData.append('description', this.description);
            EnquiryService.createEnquiry(formData)
            .then(() => {
                this.$notify({
                    title: 'Enquiry created successfully',
                    type: 'success'
                })
                this.stopLoading();
                this.$router.push({name: 'Enquiries'});
            }).catch(() => {
                this.$notify({
                    title: 'Something went wrong.',
                    type: 'error'
                })
                this.stopLoading();
            });
        }
    },
    mixins: [
        generalMixin,
        loadingMixin
    ]
}

</script>
<style lang="scss" scoped>

    .dropZone {
        width: 100%;
        height: 150px;
        position: relative;
        border: 2px dashed #97A8B8;
    }
    
    .dropZone:hover {
      border: 2px solid $primary-color;
    }
    
    .dropZone:hover .dropZone-title {
      color: $primary-color;
    }
    
    .dropZone-info {
      color: #A8A8A8;
      position: absolute;
      top: 50%;
      width: 100%;
      transform: translate(0, -50%);
      text-align: center;
    }
    
    .dropZone-title {
        color: #787878; 
    }
    
    .dropZone input {
        position: absolute;
        cursor: pointer;
        top: 0px;
        right: 0;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
    }
    
    .dropZone-upload-limit-info {
        display: flex;
        justify-content: flex-start;
        flex-direction: column;
    }
    
    .dropZone-over {
        background: #5C5C5C;
        opacity: 0.8;
    }
    
    .dropZone-uploaded {
        width: 100%;
        height: 150px;
        position: relative;
        border: 2px solid $primary-color;
        // border-radius: 10px;
    }
    
    .dropZone-uploaded-info {
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #A8A8A8;
      position: absolute;
      top: 50%;
      width: 100%;
      transform: translate(0, -50%);
      text-align: center;
    }
    
    .removeFile {
      width: 200px;
    }
    </style>